// extracted by mini-css-extract-plugin
export default {"wrap":"Highlight_wrap__iI1pt","content":"Highlight_content__S4b2p"};